import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/about">About &amp; Contact</Link>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/disclaimer">Disclaimer</Link>
      </div>
      <p>
        Results are sourced from published California Lottery data. LottoNest is an
        independent site, not affiliated with or endorsed by the California Lottery.
        Must be 18+ to play. If gambling stops being fun, help is available at
        1-800-GAMBLER.
      </p>
      <p>© {new Date().getFullYear()} LottoNest</p>
    </footer>
  );
};

export default Footer;
